
import React from 'react'
import { useParams } from 'react-router-dom'
import BookingDetailsView from '../ManageBooking/ViewBooking/BookingDetailsView'
import { getBase64Decoded, getFromSessionStorage } from '../../utils/StorageUtils';
import sessionKeys from '../../constants/sessionKeys';

const ViewPermanentBooking = () => {
	let { awbNo, ubrNo } = useParams();
	const sessionStorageData = getFromSessionStorage(sessionKeys.MULTIPLE_BOOKING_DATA)
	const decryptedData = ![undefined, null].includes(sessionStorageData) ? getBase64Decoded(sessionStorageData) : undefined;
	const isToBeProcessed = decryptedData?.fullBookingData?.status === "To be Processed"
	return (
		<div>
			<BookingDetailsView ubrNumber={!isToBeProcessed ? (ubrNo || null) : null} awbNo={!isToBeProcessed ? awbNo : null} isMutlipleBooking toBeProcessedData={isToBeProcessed ? decryptedData?.fullBookingData : null} />
		</div>
	)
}

export default ViewPermanentBooking